(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["servicios-marzo"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.srv-section').forEach(function (section) {

    // --- Slider de fondos ---
    const fondos = section.querySelectorAll('.srv-fondo');
    const fondoDots = section.querySelectorAll('.srv-fondo-dot');
    let fondoActual = 0;
    let fondoTimer = null;
    const autoplay = section.dataset.autoplay === 'true';
    const intervalo = parseInt(section.dataset.intervalo) * 1000;

    function irFondo(index) {
      fondos[fondoActual].classList.remove('active');
      if (fondoDots[fondoActual]) fondoDots[fondoActual].classList.remove('active');
      fondoActual = (index + fondos.length) % fondos.length;
      fondos[fondoActual].classList.add('active');
      if (fondoDots[fondoActual]) fondoDots[fondoActual].classList.add('active');
    }

    fondoDots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        irFondo(i);
        reiniciarFondo();
      });
    });

    function iniciarFondo() {
      if (!autoplay || fondos.length <= 1) return;
      fondoTimer = setInterval(() => irFondo(fondoActual + 1), intervalo);
    }

    function reiniciarFondo() {
      clearInterval(fondoTimer);
      iniciarFondo();
    }

    iniciarFondo();

    // --- Slider de cajones ---
    const cajones = section.querySelectorAll('.srv-cajon');
    const cajonDots = section.querySelectorAll('.srv-cajones-dot');
    const prevBtn = section.querySelector('.srv-cajones-prev');
    const nextBtn = section.querySelector('.srv-cajones-next');
    let cajonSlide = 0;
    const porSlide = 2;
    const totalSlides = Math.ceil(cajones.length / porSlide);

    function irCajon(slideIndex) {
      cajonSlide = (slideIndex + totalSlides) % totalSlides;
      const desde = cajonSlide * porSlide;
      const hasta = desde + porSlide;

      cajones.forEach(function (cajon, i) {
        cajon.classList.toggle('active', i >= desde && i < hasta);
      });

      cajonDots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === cajonSlide);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', () => irCajon(cajonSlide - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => irCajon(cajonSlide + 1));
    cajonDots.forEach(function (dot, i) {
      dot.addEventListener('click', () => irCajon(i));
    });

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.stl-wrapper').forEach(function (wrapper) {

    const dots = wrapper.querySelectorAll('.stl-dot');
    const cards = wrapper.querySelectorAll('.stl-product-card');

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const index = this.dataset.index;
        dots.forEach(d => d.classList.remove('active'));
        cards.forEach(c => c.classList.remove('active'));
        this.classList.add('active');
        const card = wrapper.querySelector('.stl-product-card[data-index="' + index + '"]');
        if (card) card.classList.add('active');
      });
    });

    wrapper.querySelectorAll('.stl-product-card').forEach(function (card) {
      const variantBtns = card.querySelectorAll('.stl-variant-btn');
      const addToCartBtn = card.querySelector('.stl-add-to-cart');

      variantBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          variantBtns.forEach(b => b.classList.remove('selected'));
          this.classList.add('selected');
          const variantId = this.dataset.variantId;
          const available = this.dataset.available === 'true';
          const price = this.dataset.variantPrice;
          if (addToCartBtn) {
            addToCartBtn.dataset.variantId = variantId;
            addToCartBtn.disabled = !available;
            addToCartBtn.textContent = available ? 'Agregar al carrito' : 'Agotado';
          }
          const priceEl = card.querySelector('.stl-price, .stl-price-sale');
          if (priceEl && price) priceEl.textContent = price;
        });
      });

      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function () {
          const variantId = this.dataset.variantId;
          const feedback = card.querySelector('.stl-feedback');
          const btn = this;

          btn.disabled = true;
          btn.textContent = 'Agregando...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
          .then(res => res.json())
          .then(function () {
            btn.textContent = '¡Agregado!';
            if (feedback) {
              feedback.textContent = '✓ Producto agregado al carrito';
              feedback.style.color = 'green';
            }
            fetch('/cart.js')
              .then(r => r.json())
              .then(function (cart) {
                const counters = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count');
                counters.forEach(el => el.textContent = cart.item_count);
              });
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = 'Agregar al carrito';
              if (feedback) feedback.textContent = '';
            }, 3000);
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = 'Agregar al carrito';
            if (feedback) {
              feedback.textContent = 'Error al agregar. Intenta de nuevo.';
              feedback.style.color = 'red';
            }
          });
        });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-novacode"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.cs-slideshow').forEach(function(slideshowEl) {
    const slides = slideshowEl.querySelectorAll('.cs-slide');
    const dots = slideshowEl.querySelectorAll('.cs-dot');
    const prevBtn = slideshowEl.querySelector('.cs-arrow-prev');
    const nextBtn = slideshowEl.querySelector('.cs-arrow-next');
    let current = 0;
    let timer = null;

    const autoplay = slideshowEl.dataset.autoplay === 'true';
    const interval = parseInt(slideshowEl.dataset.intervalo) * 1000;

    function goTo(index) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }

    function startAutoplay() {
      if (!autoplay || slides.length <= 1) return;
      timer = setInterval(() => goTo(current + 1), interval);
    }

    function resetAutoplay() {
      clearInterval(timer);
      startAutoplay();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); resetAutoplay(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); resetAutoplay(); }));

    startAutoplay();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
